import React, { Component } from "react";
import fire from "../../config/config";

export default class SupportMsg extends Component {
  state = {
    msgs: []
  };

  componentDidMount() {
    fire
      .database()
      .ref("/support")
      .on("value", snap => {
        var data = snap.val();
        var msgs = [];
        for (let i in data) {
          msgs.push({ ...data[i], key: i });
        }
        this.setState({ msgs });
      });
  }

  render() {
    var { msgs } = this.state;
    //console.log(msgs);
    if (msgs.length === 0) {
      return <div>Empty</div>;
    }
    return (
      <div>
        {msgs.map((msg, index) => (
          <div>
            <h3>{msg.fullname}</h3>
            <h4>{msg.email}</h4>
            <h4>{msg.tel}</h4>
            <p>{msg.msg}</p>
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/AdminDash/SupportMsg.js